// 이미지 모듈 설정값 (공개 페이지 shooluk-domain-page-client/src/views/[domainName]/v2/components/albumLayouts.js 와 같은 배치,
// 서버 LinkItemsMainService 의 ALBUM_LAYOUTS / CAROUSEL_RATIOS 와 값이 같아야 한다)

export const CAROUSEL_MAX_IMAGES = 10;

export const CAROUSEL_RATIOS = [
    { value: '1:1', label: '1:1 정사각형', aspect: 'aspect-square' },
    { value: '4:5', label: '4:5 세로', aspect: 'aspect-[4/5]' },
    { value: '16:9', label: '16:9 가로', aspect: 'aspect-video' },
];

// container / cell / cells: 미리보기 그림과 공개 페이지에 같은 모양을 쓰기 위한 그리드 클래스
export const ALBUM_LAYOUTS = {
    2: [
        { value: 'ROW', label: '가로 2장', container: 'grid grid-cols-2', cell: 'aspect-[4/5]' },
    ],
    4: [
        { value: 'GRID', label: '2×2', container: 'grid grid-cols-2', cell: 'aspect-square' },
        { value: 'HERO_TOP', label: '큰 1 + 작은 3', container: 'grid grid-cols-3', cell: 'aspect-square', cells: ['col-span-3 aspect-video'] },
        { value: 'HERO_LEFT', label: '왼쪽 큰 1 + 3', container: 'grid aspect-[3/2] grid-cols-3 grid-rows-3', cell: '', cells: ['col-span-2 row-span-3'] },
        { value: 'STRIP', label: '세로 4컷', container: 'mx-auto grid w-[72%] grid-cols-1', cell: 'aspect-[4/3]' },
    ],
    6: [
        { value: 'GRID_3X2', label: '3열 × 2행', container: 'grid grid-cols-3', cell: 'aspect-square' },
        { value: 'GRID_2X3', label: '2열 × 3행', container: 'grid grid-cols-2', cell: 'aspect-square' },
        { value: 'HERO', label: '큰 1 + 작은 5', container: 'grid aspect-square grid-cols-3 grid-rows-3', cell: '', cells: ['col-span-2 row-span-2'] },
    ],
};

export function findAlbumLayout(count, layout) {
    return ALBUM_LAYOUTS[count]?.find(r => r.value === layout) || ALBUM_LAYOUTS[count]?.[0];
}

// 앨범 빈 칸 채움 (사진 대신 그라데이션). imageList 에 { placeholder: 번호 } 로 저장
// 서버 ALBUM_PLACEHOLDER_COUNT 와 개수, 에디터·공개 페이지 albumLayouts.js 끼리 순서가 같아야 한다
export const ALBUM_PLACEHOLDERS = [
    'linear-gradient(135deg, #fbc2eb, #a6c1ee)',
    'linear-gradient(135deg, #fddb92, #d1fdff)',
    'linear-gradient(135deg, #a1c4fd, #c2e9fb)',
    'linear-gradient(135deg, #d4fc79, #96e6a1)',
    'linear-gradient(135deg, #ffecd2, #fcb69f)',
    'linear-gradient(135deg, #e0c3fc, #8ec5fc)',
];
